import React__default from 'react';
import { FacetLink } from './FacetLink.js';
import { useAccessibleName } from './hooks/useAccessibleName.js';

const FacetWithImage = ({ item , isActive , onPick , productType  })=>{
    const accessibleName = useAccessibleName(item);
    return /*#__PURE__*/ React__default.createElement(FacetLink, {
        item: item,
        isActive: isActive,
        onPick: onPick,
        productType: productType,
        accessibleName: accessibleName
    }, /*#__PURE__*/ React__default.createElement("img", {
        src: item.imageUrl,
        alt: accessibleName
    }));
};

export { FacetWithImage };
//# sourceMappingURL=FacetWithImage.js.map
